import {lazy} from "react";

export const AdminPanelAsync = lazy(() => import('./AdminPanel'))

